import React from 'react'
import { Registry } from '@react-registry'
import { useSlateStatic } from 'slate-react'
import Tooltip from '../../../../../Tooltip/Tooltip'
import HyperlinkOverlay, { handleLinkMouseDown, ShortcutOpenHyperlinkOverlay } from './hyperlinkOverlay'
import { unwrapLink } from './utils'
//@ts-ignore
import styles from './style.module.css'
import { elementCategories } from '../elementCategories'
import { InfoButton } from './HoverInfoTooltip'
import { ExtendedEditor } from '../../../../../../utils/types'
import Icon from '../../../../../Icon2'
import { SlashLinkIcon } from "../../utils/Icon"
export * from './deserializer'

export const Hyperlink = (props) => {
  const { url, target, title } = props.element.attrs || {}
  const editor: ExtendedEditor = useSlateStatic()

  const handleUnlink = () => {
    const selection = editor.selection || editor.savedSelection;
    if (!selection) return;
    unwrapLink(editor)
  }

  const handleOnEdit = (event) => {
    handleLinkMouseDown(event, editor)
  }

  return (
    <span className='tippy-inline'>
      <Tooltip appendTo={document.body} zIndex={909} className="p-0" position='bottom' trigger='click' variantType='light' content={
        <div contentEditable={false} className={styles['hyperlink-info-tooltip']}>
          <a href={url} target='_blank' className={styles['hyperlink-info-tooltip--url']}>{url}</a>
          <div>
            <InfoButton title='edit' content='Edit Link' onClick={handleOnEdit}>
              <Icon version='v2' icon="Edit" size='small' />
            </InfoButton>
            <InfoButton title='unlink' content='Unlink' onClick={handleUnlink}>
              <Icon version='v2' icon="Unlink" size='small' />
            </InfoButton>
          </div>
        </div>
      }
        wrapperElementType='span'
      >
        <span {...props.attributes} className={styles['hyperlink']}>
          <a data-testid="hyperlink_a" href={url} target={target} title={title}>
            {props.children}
          </a>
        </span>
      </Tooltip>
    </span>
  )
}

Registry.register(
  {
    Component: Hyperlink,
    IngressComponent: HyperlinkOverlay,
    title: 'URL',
    slashTitle: 'Link',
    slashIconName: <SlashLinkIcon />,
    keywords: ['link'],
    category: elementCategories.LINK_DROPDOWN,
    subtitle: 'Link to other websites',
    isContentStackElement: true,
    toolbar: {
      inMainToolbar: true,
      inHoveringToolbar: true,
      inSlashToolbar: true
    },
    shortcut: { key: 'mod+k', callback: ShortcutOpenHyperlinkOverlay },
    dndOptions: {
      DisableDND: true,
      DisableSelectionHalo: true
    }
  },
  { id: 'a', registry: 'v2.element' }
)

export * from './withHyperlink'
